<script>
  export let markUnseenWrapper;
  export let orderUrl;
  export let closeMenu;
  export let conversation;

  function calculateCanMarkUnseen() {
    const lastMessage = conversation.last_message || {};
    return lastMessage.seen && lastMessage.recipient == "retailer";
  }

  $: canMarkUnseen = calculateCanMarkUnseen();

</script>

<div class="retailer-header__account-popover">
  <ul class="list retailer-header__account-popover__contents default-body--regular">
    {#if canMarkUnseen}
      <li class="list-item margin-top--small margin-bottom--small margin-left--small">
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="display-block underline-hover cursor-pointer" on:click={markUnseenWrapper}
          >Mark as Unread</a
        >
      </li>
    {/if}
    <li class="list-item margin-top--small margin-bottom--small margin-left--small">
      <!-- svelte-ignore a11y-missing-attribute -->
      <a
        class="display-block underline-hover cursor-pointer"
        on:click={closeMenu}
        href={orderUrl}
        target="_blank"
        rel="noopener noreferrer">View All Orders</a
      >
    </li>
  </ul>
</div>
